<app-select
	[required]="true"
	[label]="label"
	[ngModel]="directionOfFeeSignal()"
	(ngModelChange)="setDirectionOfFee($event)"
	[intercomAttr]="intercomAttr"
	[disabled]="disabled"
	[testHook]="testHooks.SetDirectionOfFeeSelect"
>
	@for (option of directionOfFeeTypeOptions; track option.value) {
		<option [value]="option.value" [testHook]="testHooks.FeeDirectionOption">
			{{ option.label }}
		</option>
	}
</app-select>
